import React, { useEffect, useState } from "react";
import styled from "styled-components";

const Container = styled.svg`
  cursor: pointer;
  &:hover {
    fill: #15c0ef;
    path {
      fill: #fff;
    }
  }
`;

function SortDesc({ data, Column, Direction, onSort }) {
  return (
    <Container
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={() => {
        if (data == Column) {
          onSort(data, Direction == "asc" ? "desc" : "asc");
        } else {
          onSort(data, "asc");
        }
      }}
    >
      <line
        x1="16.1592"
        y1="5.76172"
        x2="4.01014"
        y2="5.76172"
        stroke="#057AFF"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="13.9609"
        y1="10.4736"
        x2="6.20862"
        y2="10.4736"
        stroke="#057AFF"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="11.6479"
        y1="15.1865"
        x2="8.52147"
        y2="15.1865"
        stroke="#057AFF"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Container>
  );
}

export default SortDesc;
